/* globals VXConfig */
import React                            from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import PjaxWrapper                      from '../../utils/PjaxWrapper';
import DailyBonusPage                   from '../../components/DailyBonusPage/DailyBonusPage';
import ActorCardsSlider                 from '../../components/ActorCardsSlider/ActorCardsSlider';
//import DailyBonusActionsSlider          from '../../components/DailybonusActionsSlider/DailyBonusActionsSlider';
import SubscribeToContests              from './SubscribeToContests';
import CollectedOffersList              from './CollectedOffersList';
import {VXPay}                          from '../../utils/VXPay';
import ReloadHelper                     from "../../utils/ReloadHelper";
import UrlBuilder                       from "../../utils/UrlBuilder";
import Flux                             from "../../flux/Flux";

const openVipPaytour = () => {
	if (!VXConfig.guestIsLoggedIn) {
		VXPay.openLogin();
		return;
	}
	if (Flux.Guest.isVip()) {
		ReloadHelper.reload(UrlBuilder.buildVIPClubUrl());
		return;
	}
	VXPay.openAboPaytour();
};

function run(pmJson) {
	const pm         = JSON.parse(pmJson);
	pm.show          = true;
	const bonus365El = document.getElementById('daily-bonus-page__bonus365');
	if (bonus365El) {
		render(<DailyBonusPage pm={pm} />, bonus365El);
	}

	const actorSliderEl = document.getElementById('daily-bonus-page__actor-slider');
	if (actorSliderEl) {
		render(<ActorCardsSlider />, actorSliderEl);
	}

//	const actionsSliderEl = document.getElementById('daily-bonus-page__participate-in-actions__actions-slider');
//	if (actionsSliderEl) {
//		render(<DailyBonusActionsSlider />, actionsSliderEl);
//	}

	const subscriptionInputEl = document.getElementById('daily-bonus-page__participate-in-actions__subscription-form-input');
	if (subscriptionInputEl) {
		render(<SubscribeToContests />, subscriptionInputEl);
	}

	const collectedOffersEl = document.getElementById('daily-bonus-page__collected-offers-items');
	if (collectedOffersEl) {
		render(<CollectedOffersList messengerLink={pm.messengerLink} becomeVipLink={pm.becomeVipLink} />, collectedOffersEl);
	}

	const collection = document.getElementsByClassName('daily-bonus-page__all-bonuses-info--item-title--vip-one-day');
	const vipButton  = collection.length > 0 ? collection.item(0) : false;
	if (vipButton) {
		vipButton.addEventListener('click', openVipPaytour);
	}


	PjaxWrapper.addUnloadFunc(() => {
		!!bonus365El          && unmountComponentAtNode(bonus365El);
		!!actorSliderEl       && unmountComponentAtNode(actorSliderEl);
//		!!actionsSliderEl     && unmountComponentAtNode(actionsSliderEl);
		!!subscriptionInputEl && unmountComponentAtNode(subscriptionInputEl);
		!!collectedOffersEl   && unmountComponentAtNode(collectedOffersEl);
		!!vipButton           && vipButton.removeEventListener('click', openVipPaytour);
	});
}

export {run};

